import * as React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as ReportModule from 'Modules/ReportModule';
import i18next from 'i18next';

type P = {
    //
};
type S = {
    //
};
type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
    t?: i18next.TFunction;
};

class CarMainReport extends React.Component<P & ConnectedP, S> {
    public render() {
        const {reportStore, t} = this.props;
        if (reportStore.carMainReport) {
            return (
                <div className="report report__info">
                    <p className="font-bold mb-20">
                        <span className="font-blue">
                            {t('dataRangeDays')}: {reportStore.carMainReport.dataRangeDays}
                        </span>
                    </p>
                    <p className="font-bold mt-20 mb-20">{reportStore.carMainReport.dataRange}</p>
                    <div className="flex flex--wrap">
                        <div className="mr-20">
                            <p className="font-bold">{t('addressStart')}</p>
                            <p className="">{reportStore.carMainReport.startAddress}</p>
                            <p className="mt-10">
                                {t('startMileageKm')} <span
                                className="font-bold">{reportStore.carMainReport.startMileageKm}</span>
                            </p>
                        </div>
                        <div className="">
                            <p className="font-bold">{t('addressEnd')}</p>
                            <p className="">{reportStore.carMainReport.endAddress}</p>
                            <p className="mt-10">
                                {t('endMileageKm')} <span
                                className="font-bold">{reportStore.carMainReport.endMileageKm}</span>
                            </p>
                        </div>
                    </div>
                    <div className="mt-20">
                        <p className="font-bold font-blue">{t('reportSummary')}</p>
                        <ReportBlock title={t('gpsDistance')} value={`${reportStore.carMainReport.distanceGpsKm}`}/>
                        <ReportBlock title={t('maxSpeedKmh')} value={`${reportStore.carMainReport.maxSpeedKmh}`}/>
                        <ReportBlock title={t('avgSpeedKmh')} value={`${reportStore.carMainReport.avgSpeedKmh}`}/>
                        <ReportBlock title={t('gpsSignal')} value={`${reportStore.carMainReport.gpsSignal}`}/>
                        <ReportBlock title={t('gsmSignal')} value={`${reportStore.carMainReport.gsmSignal}`}/>
                        <ReportBlock title={t('dataframesCount')}
                                     value={`${reportStore.carMainReport.dataframesCount}`}/>
                    </div>
                    <div className="mt-20">
                        <TimeSpentCountries title={t('timeSpend')}
                                            inPoland={reportStore.carMainReport.timeSpentInCountry}
                                            outsidePoland={reportStore.carMainReport.timeSpentAbroad} t={t}/>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}

export default withTranslation('reports')(connect(mapStateToProps)(CarMainReport) as React.ComponentType<any>);

export const ReportBlock = (props: { title: string; value: any }): JSX.Element => {
    return (
        <div className="report-list__block">
            <div className="report-list__title">{props.title}</div>
            <div className="report-list__value">{props.value || '-'}</div>
        </div>
    );
};
export const TimeSpentCountries = (props: { title: string; inPoland: string; outsidePoland: string; t: i18next.TFunction }) => (
    <>
        <p className="font-bold font-blue">
            {props.title}
        </p>
        <ReportBlock title={props.t('inPoland')} value={props.inPoland}/>
        <ReportBlock title={props.t('outsidePoland')} value={props.outsidePoland}/>
    </>
);



// WEBPACK FOOTER //
// ./src/components/Raports/ReportsComposites/CarMainReport.tsx